// extracted by mini-css-extract-plugin
export default {"grid_box":"ResponsiveImageGallery_grid_box__lo37r"};